import { render } from "./ResultView.vue?vue&type=template&id=f2779e28&scoped=true"
import script from "./ResultView.vue?vue&type=script&lang=js"
export * from "./ResultView.vue?vue&type=script&lang=js"

import "./ResultView.vue?vue&type=style&index=0&id=f2779e28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2779e28"]])

export default __exports__